// Can be deleted if all refactor works
//
// function initializeFlatpickr(callback) {
//     flatpickr('.flatpickr', {
//         locale: 'sv',
//         wrap: true,
//         mode: 'range',
//         altInput: true,
//         altFormat: 'j F, Y',
//         dateFormat: 'Y-m-d',
//         utc: true,
//         onChange: function(selectedDates, dateStr, instance) {
//             var tzOffset = new Date().getTimezoneOffset();
//
//             var adjustedDates = selectedDates.map(function(date) {
//                 return new Date(date.getTime() - tzOffset * 60000);
//             });
//
//             if (typeof callback === 'function') {
//                 callback(adjustedDates);
//             }
//         },
//     });
// }
//
// flatpickr('.flatpickr', {
//         'locale': 'sv',
//         wrap: true,
//         mode: 'range',
//         altInput: true,
//         altFormat: 'j F, Y',
//         dateFormat: 'Y-m-d',
//         disableMobile: true,
//     minDate: "today",
//     },
// );
//
// // Calendar on booking request
// document.addEventListener("DOMContentLoaded", function () {
//     // Hämta input-fälten
//     const firstPickerWrapper = document.querySelector(".flatpickr-single");
//     const secondPickerWrapper = document.querySelector(".flatpickr-single-tomorrow");
//
//     // Se till att båda elementen finns innan vi initierar Flatpickr
//     if (!firstPickerWrapper || !secondPickerWrapper) {
//         console.error("Flatpickr-elementen hittades inte.");
//         return;
//     }
//
//     // Initiera andra kalendern
//     const secondDatePicker = flatpickr(secondPickerWrapper, {
//         locale: "sv",
//         wrap: true,
//         mode: "single",
//         altInput: false,
//         altFormat: "Y-m-d",
//         dateFormat: "j F",
//         disableMobile: true,
//         minDate: "today",
//     });
//
//     // Initiera första kalendern
//     flatpickr(firstPickerWrapper, {
//         locale: "sv",
//         wrap: true,
//         mode: "single",
//         altInput: false,
//         altFormat: "Y-m-d",
//         dateFormat: "j F",
//         disableMobile: true,
//         minDate: "today",
//         onChange: function (selectedDates) {
//             if (selectedDates.length > 0) {
//                 let nextDay = new Date(selectedDates[0]);
//                 nextDay.setDate(nextDay.getDate() + 1);
//
//                 // Uppdatera den andra kalendern korrekt
//                 secondDatePicker.setDate(nextDay, true);
//             }
//         }
//     });
//
//     // detailed request
//     // Hämta input-fälten
//     const firstPickerWrapperLong = document.querySelector(".flatpickr-single-long");
//     const secondPickerWrapperLong = document.querySelector(".flatpickr-single-tomorrow-long");
//
//     // Se till att båda elementen finns innan vi initierar Flatpickr
//     if (!firstPickerWrapperLong || !secondPickerWrapperLong) {
//         console.error("Flatpickr-elementen hittades inte.");
//         return;
//     }
//
//     // Initiera andra kalendern
//     const secondDatePickerLong = flatpickr(secondPickerWrapperLong, {
//         locale: "sv",
//         wrap: true,
//         mode: "single",
//         altInput: false,
//         altFormat: "Y-m-d",
//         dateFormat: "j F",
//         disableMobile: true,
//         minDate: "today",
//     });
//
//     // Initiera första kalendern
//     flatpickr(firstPickerWrapperLong, {
//         locale: "sv",
//         wrap: true,
//         mode: "single",
//         altInput: false,
//         altFormat: "Y-m-d",
//         dateFormat: "j F",
//         disableMobile: true,
//         minDate: "today",
//         onChange: function (selectedDates) {
//             if (selectedDates.length > 0) {
//                 let nextDay = new Date(selectedDates[0]);
//                 nextDay.setDate(nextDay.getDate() + 1);
//
//                 // Uppdatera den andra kalendern korrekt
//                 secondDatePickerLong.setDate(nextDay, true);
//             }
//         }
//     });
// });
//
// flatpickr('.flatpickrTime-from', {
//     enableTime: true,
//     noCalendar: true,
//     dateFormat: "H:i",
//     time_24hr: true,
//     minuteIncrement: 15,
//     minTime: "06:00",
//     maxTime: "21:00",
//     defaultDate: "08:00"
// });
//
// flatpickr('.flatpickrTime-to', {
//     enableTime: true,
//     noCalendar: true,
//     dateFormat: "H:i",
//     time_24hr: true,
//     minuteIncrement: 15,
//     minTime: "06:00",
//     maxTime: "21:00",
//     defaultDate: "17:00"
// });

// Refactor the all block

function initializeFlatpickrRange(selector, callback) {
    flatpickr(selector, {
        locale: 'sv',
        wrap: true,
        mode: 'range',
        altInput: true,
        altFormat: 'j F, Y',
        dateFormat: 'Y-m-d',
        minDate: "today",
        disableMobile: true,
        utc: true,
        onChange(selectedDates) {
            const tzOffset = new Date().getTimezoneOffset();
            const adjustedDates = selectedDates.map(date =>
                new Date(date.getTime() - tzOffset * 60000)
            );
            if (typeof callback === 'function') {
                callback(adjustedDates);
            }
        }
    });
}

function initializeSinglePair(fromSelector, toSelector) {
    const fromEl = document.querySelector(fromSelector);
    const toEl = document.querySelector(toSelector);
    if (!fromEl || !toEl) {
        console.error("Flatpickr-elementen hittades inte:", fromSelector, toSelector);
        return;
    }

    const toPicker = flatpickr(toEl, {
        locale: "sv",
        wrap: true,
        mode: "single",
        altInput: true,
        altFormat: "j F",
        dateFormat: "Y-m-d",
        disableMobile: true,
        minDate: "today",
    });

    flatpickr(fromEl, {
        locale: "sv",
        wrap: true,
        mode: "single",
        altInput: true,
        altFormat: "j F",
        dateFormat: "Y-m-d",
        disableMobile: true,
        minDate: "today",
        onChange(selectedDates) {
            if (selectedDates.length > 0) {
                const nextDay = new Date(selectedDates[0]);
                nextDay.setDate(nextDay.getDate() + 1);
                toPicker.setDate(nextDay, true);
            }
        }
    });
}

function initializeTimePicker(selector, defaultTime) {
    flatpickr(selector, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        minuteIncrement: 15,
        minTime: "06:00",
        maxTime: "21:00",
        disableMobile: true,
        defaultDate: defaultTime,
    });
}

// Initiera allt när DOM laddats
document.addEventListener("DOMContentLoaded", function () {
    initializeFlatpickrRange('.flatpickr');

    initializeSinglePair('.flatpickr-single', '.flatpickr-single-tomorrow');
    initializeSinglePair('.flatpickr-single-long', '.flatpickr-single-tomorrow-long');

    initializeTimePicker('.flatpickrTime-from', '08:00');
    initializeTimePicker('.flatpickrTime-to', '17:00');
});

//# sourceMappingURL=flatpickr-settings.js.map
